import React, { useState } from "react";
import {
  capitalize,
  formatCurrencyValue,
  getFullName,
} from "../../helper-methods";
import ShowMediaModal from "../modals/ShowMediaModal";

const ChatAudio = ({ message, fan }) => {
  const [showMediaModal, setShowMediaModal] = useState({
    isOpen: false,
    externalLink: "",
    contentType: "",
  });

  const _toggleShowMediaModal = (
    isOpen = false,
    externalLink = "",
    contentType = ""
  ) => {
    setShowMediaModal({
      isOpen,
      externalLink,
      contentType,
    });
  };

  return (
    <>
      <div
        className="mediaAudioWrap"
        onClick={() => {
          _toggleShowMediaModal(
            true,
            message?.content?.[0]?._contentId?.url,
            "audio"
          );
        }}
      >
        <img src="/assets/img/mic.png" alt="Microphone" loading="lazy" />
        {!message.isPublic ? (
          <div className="msgPrice">
            {message?.content?.[0]?.amount
              ? formatCurrencyValue(message.content[0].amount)
              : message.amount
              ? formatCurrencyValue(message.amount)
              : ""}
          </div>
        ) : null}
      </div>

      {message?.hasPurchased ? (
        <div className="paidMessageText">
          {fan?.name?.full || fan?.name?.first
            ? capitalize(getFullName(fan.name))
            : "Fan"}{" "}
          Paid{" "}
          {message?.content?.[0]?.amount
            ? formatCurrencyValue(message.content[0].amount)
            : message.amount
            ? formatCurrencyValue(message.amount)
            : ""}{" "}
          for this message
        </div>
      ) : null}

      {showMediaModal.externalLink ? (
        <ShowMediaModal
          isOpen={showMediaModal.isOpen}
          externalLink={showMediaModal.externalLink}
          contentType={showMediaModal.contentType}
          toggle={() => _toggleShowMediaModal()}
        />
      ) : null}
    </>
  );
};

export default ChatAudio;
